(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-edits"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const videos = document.querySelectorAll('.Index_arrivals_details_main_new video');
  
  videos.forEach(video => {
    if(video) {
      video.setAttribute('alt', 'saree video');
      video.setAttribute('playsinline', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('loop', '');
      video.setAttribute('muted', '');
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
